import { Dialog, Modal } from 'react-aria-components';
import cx from 'clsx';
import type { ModalOverlayProps as AriaModalProps } from 'react-aria-components';
import type { ReactElement } from 'react';
import type { AriaDialogProps } from 'react-aria';
import styles from '../popup.module.css';

export interface PopupRootProps
  extends Omit<AriaModalProps, 'UNSTABLE_portalContainer'>, AriaDialogProps {
  children: ReactElement | ReactElement[];
  portalContainer?: Element;
}

export function PopupRoot({
  children,
  className,
  portalContainer,
  ...props
}: PopupRootProps): ReactElement {
  const { 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, ...restProps } = props;

  // react-aria modal escapes the test container, we render it where it can find the modal (i.e. <div> component with 'ember-testing' id)
  const TEST_PORTAL_CONTAINER =
    document.getElementById('ember-testing') ??
    document.getElementById('storybook-root') ??
    undefined;

  return (
    <Modal
      className={cx(styles.wrapper, className)}
      {...restProps}
      UNSTABLE_portalContainer={portalContainer ?? TEST_PORTAL_CONTAINER}
    >
      <Dialog aria-label={ariaLabel} aria-labelledby={ariaLabelledBy} className={styles.dialog}>
        {children}
      </Dialog>
    </Modal>
  );
}
